import { AxiosRequestConfig } from 'axios'
import { RetDataType } from './request'
import { requestQueue } from './common'
import processQueue from './processQueue'

/**
 * 基于 axios 二次封装的 request 方法，系统统一的网络请求方法
 * @param options 请求配置项目，具体查看 https://github.com/axios/axios
 * @returns Promise<RetDataType<T>>
 */
export function escRequest<T>(options: AxiosRequestConfig): Promise<RetDataType<T>> {
  return new Promise((resolve, reject) => {
    requestQueue.push({ ...options, resolve, reject, retires: 0 })
    processQueue()
  })
}
